var _circle, _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyFittedLenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F5FAFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 20.2782,
    height: 34.811,
    rx: 5.2508,
    transform: "matrix(0.91708 0.399235 -0.449016 0.893781 53.7539 27.873)",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.379139,
    y: 1.04736,
    width: 23.3278,
    height: 43.2336,
    rx: 1.81544,
    transform: "matrix(0.917056 0.399283 -0.448962 0.893806 50.3112 25.2216)",
    stroke: "#011E29",
    strokeWidth: 1.61993
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5109 33.2502L63.0605 36.9782M38.5542 61.6017L49.9537 66.5723",
    stroke: "#011E29",
    strokeWidth: 1.75027,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1429 47.7923L68.6226 50.9355L71.6976 53.5036",
    stroke: "#011E29",
    strokeWidth: 1.75027,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1657 32.6959L37.8297 37.2246L33.7399 36.6754",
    stroke: "#011E29",
    strokeWidth: 1.75027,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyFittedLenses);
export default __webpack_public_path__ + "static/media/buy-fitted-lenses.ea64b0a8c6ba8aca648469be1910d460.svg";
export { ForwardRef as ReactComponent };